import { render, staticRenderFns } from "./InspectorPanel.vue?vue&type=template&id=9ad0e7dc&scoped=true&"
import script from "./InspectorPanel.vue?vue&type=script&lang=js&"
export * from "./InspectorPanel.vue?vue&type=script&lang=js&"
import style0 from "./inspector.scss?vue&type=style&index=0&id=9ad0e7dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad0e7dc",
  null
  
)

export default component.exports